export default {
    code: null,
    message: null
};
